"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var dedup = function dedup(array) {
    if (!array || !array.filter) {
        return array;
    }
    return array.filter(function (item, pos, arr) {
        return arr.indexOf(item) === pos;
    });
};

exports.default = dedup;
module.exports = exports['default'];